export default {
  en: {
    clear: 'Clear filters',
    noResultsFound: {
      title: 'No results found',
      subtitle: 'Try changing your filters.',
    },
  },
  es: {
    clear: 'Borrar filtros',
    noResultsFound: {
      title: 'No se encontraron resultados',
      subtitle: 'Intenta cambiar tus filtros',
    },
  },
  fr: {
    clear: 'Effacer les filtres',
    noResultsFound: {
      title: 'Aucun résultat trouvé',
      subtitle: 'Essayez de modifier vos filtres.',
    },
  },
}
